import debounce from 'lodash';
import breakpoints from '../utils/breakpoints';

export default {

  getBreakpoint(key) {
    if ( key === parseInt(key,10) ) return key;
    return breakpoints[key];
  },

  debounced(fn) {
    return _.debounce( () => fn(), 200);
  },

  isMaxWidth(key) {
    return window.innerWidth < this.getBreakpoint(key);
  },

  isMinWidth(key) {
    return window.innerWidth >= this.getBreakpoint(key);
  },

  // ENHANCEMENT: fallback or 'else' function chain
  onMaxWidth(key, callback, execute=true) {
    if ( execute && this.isMaxWidth(key) ) callback();

    let debounced = this.debounced( () => {
      if ( this.isMaxWidth(key) ) callback();
    });
    window.addEventListener('resize', debounced);
    window.addEventListener('popstate', debounced.cancel);
  },

  onMinWidth(key, callback, execute=true) {
    if ( execute && this.isMinWidth(key) ) callback();

    let debounced = this.debounced( () => {
      if ( this.isMinWidth(key) ) callback();
    });
    window.addEventListener('resize', debounced);
    window.addEventListener('popstate', debounced.cancel);
  },

}
